// Color scales from docs/STYLE.md section 3.1. Scale values are never used in components -
// components use the semantic theme names from ./themes.ts (Tailwind: bg-primary, text-color, ...).
// Space, size and the radius names come from @tamagui/config/v6: its space scale is already the
// 4 px raster STYLE.md asks for (p-4 = 16px), and its radius names are xs/sm/md/lg/xl/2xl/3xl/4xl/
// full, which cover every value in STYLE.md except the 20 px card radius added below.
export const blue = {
  'blue-50': '#EFF4FF',
  'blue-100': '#DFE8FF',
  'blue-200': '#C3D4FF',
  'blue-300': '#9AB5FD',
  'blue-400': '#6C90F7',
  'blue-500': '#4470EC',
  'blue-600': '#2C57D4',
  'blue-700': '#2145AE',
  'blue-800': '#1B3889',
  'blue-900': '#162C6B',
}

export const neutral = {
  white: '#FFFFFF',
  'neutral-25': '#FAFBFC',
  'neutral-50': '#F5F7FA',
  'neutral-100': '#EDF0F5',
  'neutral-200': '#E1E6ED',
  'neutral-300': '#CED5DF',
  'neutral-400': '#A3ADBC',
  'neutral-500': '#78849A',
  'neutral-550': '#66718A',
  'neutral-600': '#566175',
  'neutral-700': '#3C4557',
  'neutral-800': '#232B3B',
  'neutral-900': '#121826',
}

export const signal = {
  'green-50': '#EAF8EF',
  'green-100': '#CFEFDB',
  'green-600': '#16803C',
  'green-700': '#11662F',
  'green-800': '#0D4F25',
  'amber-50': '#FFF5DB',
  'amber-100': '#FDE8B0',
  'amber-600': '#B45309',
  'amber-800': '#6B3206',
  'red-50': '#FEEDEC',
  'red-100': '#FBD5D2',
  'red-600': '#C62A22',
  'red-700': '#A3201A',
  'red-800': '#7F1A15',
}

/** 20 px card radius from STYLE.md section 3.2, the one value v6 has no name for. */
export const extraRadius = { card: 20 }

// STYLE.md names its layers (nav/popover/overlay/dialog/toast); Tamagui 3 only accepts a subset of
// its own numeric zIndex scale, so the layers map onto it: nav z-10, popover z-20, overlay z-30,
// dialog z-40, toast z-48.
